import {
  Button,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import color from "../../../Constants/colors";
import ScrollToTop from "../../ScrollToTop/ScrollToTop";
import { IPaymentInformation } from "../../../Model/Order";

interface ISingleCartProductProps {
  productID: number;
  productName: string;
  productPrice: number;
  productImage: string;
  productAmount: number;
  productColor: string;
  productAvailableNow: boolean;
}

const SingleCartProduct = ({
  productID,
  productName,
  productPrice,
  productImage,
  productAmount,
  productColor,
  productAvailableNow,
}: ISingleCartProductProps): JSX.Element => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const totalProductPrice = productPrice * productAmount;

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return screenWidth > 785 ? ( // HORIZONTAL
    <TableRow>
      <TableCell>
        <Grid
          container
          sx={{
            display: "flex",
            flexDirection: "row",
            marginTop: "15px",
            marginBottom: "15px",
            marginRight: "15px",
          }}
        >
          <Grid
            item
            onClick={() => {
              window.open(
                `https://jewelryshopdoro.com/products/${productID}`,
                "_blank"
              );
            }}
          >
            <img
              style={{
                width: "130px",
                height: "150px",
                marginRight: "8px",
                objectFit: "cover",
              }}
              src={`https://jewelryshopdoro.com/uploads/${productImage}`}
              alt="Korpa Slika"
            ></img>
          </Grid>
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{ fontSize: "18px", color: "#201A12" }}
              onClick={() => {
                window.open(
                  `https://jewelryshopdoro.com/products/${productID}`,
                  "_blank"
                );
              }}
            >
              {productName}
            </Typography>
          </Grid>
        </Grid>
      </TableCell>
      <TableCell>
        <Typography
          sx={{ fontSize: "18px", color: "#201A12", marginRight: "15px" }}
        >{`${productPrice} rsd`}</Typography>
      </TableCell>
      <TableCell>
        <Typography
          sx={{ fontSize: "18px", color: "#201A12", marginRight: "15px" }}
        >{`${productAmount}`}</Typography>
      </TableCell>
      <TableCell>
        <Typography
          sx={{ fontSize: "18px", color: "#C6912E", marginRight: "15px" }}
        >
          {`${totalProductPrice.toFixed(2)} rsd`}
        </Typography>
      </TableCell>
    </TableRow>
  ) : (
    // VERTICAL
    <TableRow>
      <TableCell>
        <Grid
          container
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Grid
            container
            sx={{
              display: "flex",
              flexDirection: screenWidth > 500 ? "row" : "column",
              alignContent: "center",
              alignItems: "center",
              marginBottom: "20px",
              justifyContent: "center",
            }}
          >
            <Grid
              item
              onClick={() => {
                window.open(
                  `https://jewelryshopdoro.com/products/${productID}`,
                  "_blank"
                );
              }}
            >
              <img
                style={{
                  width: "130px",
                  height: "150px",
                  marginRight: screenWidth > 500 ? "20px" : "0px",
                  objectFit: "cover",
                }}
                src={`https://jewelryshopdoro.com/uploads/${productImage}`}
                alt="Korpa Slika"
              ></img>
            </Grid>
            <Grid
              item
              sx={{
                display: "flex",
                flexDirection: "column",
                textAlign: screenWidth > 500 ? "left" : "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: screenWidth > 500 ? "18px" : "24px",
                  color: "#201A12",
                }}
                onClick={() => {
                  window.open(
                    `https://jewelryshopdoro.com/products/${productID}`,
                    "_blank"
                  );
                }}
              >
                {productName}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginBottom: "20px",
              marginTop: "40px",
            }}
          >
            <Typography sx={{ fontSize: "18px", color: "#201A12" }}>
              Cena
            </Typography>
            <Typography
              sx={{ fontSize: "18px", color: "#201A12" }}
            >{`${productPrice} rsd`}</Typography>
          </Grid>
          <Grid
            container
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <Typography sx={{ fontSize: "18px", color: "#201A12" }}>
              Količina
            </Typography>
            <Typography
              sx={{ fontSize: "18px", color: "#201A12" }}
            >{`${productAmount}`}</Typography>
          </Grid>
          <Grid
            container
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <Typography sx={{ fontSize: "18px", color: "#201A12" }}>
              Ukupno
            </Typography>
            <Typography sx={{ fontSize: "18px", color: "#C6912E" }}>
              {`${totalProductPrice.toFixed(2)} rsd`}
            </Typography>
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
};

const PaymentFailed = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [cartProductsString, setCartProductsString] = useState("");
  const [orderInformationString, setOrderInformationString] = useState("");
  const navigate = useNavigate();
  const [paymentInformation, setPaymentInformation] =
    useState<IPaymentInformation>({});
  useEffect(() => {
    // Load products and order info from session storage
    const newStorageData = sessionStorage.getItem("products");
    if (newStorageData !== null) {
      setCartProductsString(newStorageData);
    }
    const newOrderInformationString =
      sessionStorage.getItem("orderInformation");
    if (newOrderInformationString !== null) {
      setOrderInformationString(newOrderInformationString);
    }

    // Handle resize event
    window.addEventListener("resize", handleResize);

    const query = new URLSearchParams(window.location.search);
    const paymentInfo = {
      date: query.get("date") || undefined,
      auth_code: query.get("auth_code") || undefined,
      order_id: query.get("order_id") || undefined,
      response: query.get("response") || undefined,
      proc_return_code: query.get("proc_return_code") || undefined,
      md_status: query.get("md_status") || undefined,
    };
    setPaymentInformation(paymentInfo);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [navigate]);

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  if (cartProductsString && orderInformationString) {
    const cartProducts = JSON.parse(cartProductsString);
    let totalOrderPrice = 0.0;
    for (let singleCartProduct of cartProducts) {
      totalOrderPrice += singleCartProduct.price * singleCartProduct.amount;
    }

    const orderInformation = JSON.parse(orderInformationString);

    // Clear order data
    sessionStorage.removeItem("orderInformation");
    sessionStorage.removeItem("customerNote");

    return (
      <Grid
        container
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "27px",
        }}
      >
        <ScrollToTop />
        <Grid item sx={{ marginTop: "40px", textAlign: "center" }}>
          <Typography
            sx={{
              fontSize: "36px",
              color: "#201A12",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            Došlo je do greške prilikom plaćanja!
          </Typography>
        </Grid>
        <Grid item sx={{ textAlign: "center" }}>
          <Typography
            sx={{
              fontSize: screenWidth > 345 ? "24px" : "20px",
              color: "#201A12",
            }}
          >
            Na e-mail ćete dobiti podatke o pokušaju uplate
          </Typography>
        </Grid>
        <Grid item sx={{ marginTop: "65px" }}>
          <Grid item>
            <TableContainer>
              <Table>
                {screenWidth > 785 ? (
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Typography sx={{ fontSize: "20px", color: "#201A12" }}>
                          Proizvod
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography sx={{ fontSize: "20px", color: "#201A12" }}>
                          Cena
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography sx={{ fontSize: "20px", color: "#201A12" }}>
                          Količina
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography sx={{ fontSize: "20px", color: "#201A12" }}>
                          Ukupno
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                ) : null}
                <TableBody>
                  {cartProducts.map((singleCartProduct: any, index: number) => {
                    return (
                      <SingleCartProduct
                        key={index}
                        productID={singleCartProduct.id}
                        productName={singleCartProduct.product_name}
                        productPrice={singleCartProduct.price}
                        productImage={singleCartProduct.main_image}
                        productAmount={singleCartProduct.amount}
                        productColor={singleCartProduct.color}
                        productAvailableNow={singleCartProduct.availableNow}
                      />
                    );
                  })}
                  <TableRow>
                    <TableCell colSpan={screenWidth > 785 ? 4 : 1}>
                      <Typography
                        sx={{
                          fontSize: "20px",
                          color: "#201A12",
                          textAlign: "center",
                        }}
                      >
                        {`Ukupna cena porudžbine: ${totalOrderPrice.toFixed(
                          2
                        )} rsd`}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
        <Grid item sx={{ marginTop: "40px", textAlign: "center" }}>
          <Typography
            sx={{
              fontSize: "24px",
              color: "#201A12",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            Jewelry Shop Doro
          </Typography>
        </Grid>
        <Grid item sx={{ marginTop: "40px", textAlign: "center" }}>
          <Button
            onClick={() => navigate("/products")}
            sx={{
              textTransform: "none",
              border: "1px solid #201A12",
              borderRadius: "999px",
              paddingLeft: "28px",
              paddingRight: "28px",
              paddingTop: "12px",
              paddingBottom: "12px",
              color: "#201A12",
              "&:hover": { backgroundColor: "#201A12", color: "#FFFFFF" },
            }}
          >
            <Typography sx={{ fontSize: "18px", color: "inherit" }}>
              {"< Nazad na radnju"}
            </Typography>
          </Button>
        </Grid>
        <Grid item>
          <Grid
            container
            direction="row"
            justifyContent="space-around"
            alignItems="center"
            sx={{ marginTop: "40px", textAlign: "center" }}
          >
            <Grid item>
              <Typography
                sx={{
                  fontSize: screenWidth > 345 ? "15px" : "10px",
                  color: "#201A12",
                }}
              >
                Date: {paymentInformation.date ?? "/"}
              </Typography>
              <Typography
                sx={{
                  fontSize: screenWidth > 345 ? "15px" : "10px",
                  color: "#201A12",
                }}
              >
                Auth Code: {paymentInformation.auth_code ?? "/"}
              </Typography>
              <Typography
                sx={{
                  fontSize: screenWidth > 345 ? "15px" : "10px",
                  color: "#201A12",
                }}
              >
                Order ID: {paymentInformation.order_id ?? "/"}
              </Typography>
              <Typography
                sx={{
                  fontSize: screenWidth > 345 ? "15px" : "10px",
                  color: "#201A12",
                }}
              >
                Response: {paymentInformation.response ?? "/"}
              </Typography>
              <Typography
                sx={{
                  fontSize: screenWidth > 345 ? "15px" : "10px",
                  color: "#201A12",
                }}
              >
                Proc Return Code: {paymentInformation.proc_return_code ?? "/"}
              </Typography>
              <Typography
                sx={{
                  fontSize: screenWidth > 345 ? "15px" : "10px",
                  color: "#201A12",
                }}
              >
                MD Status: {paymentInformation.md_status ?? "/"}
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                sx={{
                  fontSize: screenWidth > 345 ? "15px" : "10px",
                  color: "#201A12",
                }}
              >
                Ime: {orderInformation.customer_name}
              </Typography>
              <Typography
                sx={{
                  fontSize: screenWidth > 345 ? "15px" : "10px",
                  color: "#201A12",
                }}
              >
                Prezime: {orderInformation.customer_surname}
              </Typography>
              <Typography
                sx={{
                  fontSize: screenWidth > 345 ? "15px" : "10px",
                  color: "#201A12",
                }}
              >
                Email: {orderInformation.email}
              </Typography>
              <Typography
                sx={{
                  fontSize: screenWidth > 345 ? "15px" : "10px",
                  color: "#201A12",
                }}
              >
                Adresa: {orderInformation.adress}
              </Typography>
              <Typography
                sx={{
                  fontSize: screenWidth > 345 ? "15px" : "10px",
                  color: "#201A12",
                }}
              >
                Opština: {orderInformation.municipality}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{ height: "100%" }}
      >
        <CircularProgress sx={{ color: color.accent }} />
      </Grid>
    );
  }
};

export default PaymentFailed;
